import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { Img } from "../common/Img";
import { useLanguage } from "../../context/LanguageContext";
import { resolveImageUrl } from "../../services/catalogService";

export function ArticleModal({ article, open, onClose }) {
  const { localize } = useLanguage();
  if (!article) return null;
  const body = localize(article, "body", []);

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent
        className="max-h-[90vh] max-w-2xl overflow-y-auto border-none bg-[#F6F2EC] p-0"
        data-testid="article-modal"
      >
        <div className="relative h-60 bg-[#EDE8E0]">
          {article.image && (
            <Img
              src={resolveImageUrl(article.image)}
              alt={localize(article, "title")}
              className="absolute inset-0 h-full w-full object-cover"
            />
          )}
        </div>
        <div className="p-8 md:p-10">
          <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.16em] text-[#D92A47]">
            <span>{localize(article, "category")}</span>
            <span className="text-[#817B74]">· {article.date}</span>
          </div>
          <DialogHeader className="space-y-0 text-left">
            <DialogTitle className="mt-3 font-serif text-3xl font-medium leading-tight text-[#252525] md:text-4xl">
              {localize(article, "title")}
            </DialogTitle>
          </DialogHeader>
          <div className="mt-5 space-y-4 text-[15px] leading-relaxed text-[#5f5a54]">
            {body.map((paragraph, index) => (
              <p key={`${article.id}-${index}`}>{paragraph}</p>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export function InfoModal({ open, onClose, title, children }) {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent
        className="max-w-xl border-none bg-[#F6F2EC]"
        data-testid="info-modal"
      >
        <DialogHeader className="text-left">
          <DialogTitle className="font-serif text-3xl font-medium text-[#252525]">
            {title}
          </DialogTitle>
        </DialogHeader>
        <div className="text-[15px] leading-relaxed text-[#5f5a54]">{children}</div>
      </DialogContent>
    </Dialog>
  );
}
